<template>
  <div>
    <div v-if="!terms">
      <div class="w-32 mx-auto pt-12">
        <logo-black :width="'w-32'" :height="'h-12'"></logo-black>
      </div>
      <div class="pt-7">
        <div class="text-2xl font-extrabold">Create your account</div>
      </div>
      <div class="text-left px-6">
        <div class="pt-8">
          <input-text type="text" v-model="first_name" placeholder="First Name"></input-text>
        </div>
        <div class="pt-3">
          <input-text type="text" v-model="last_name" placeholder="Last Name"></input-text>
        </div>
        <div class="pt-3">
          <input-text type="email" v-model="email" placeholder="Email (Optional)"></input-text>
        </div>
        <div class="pt-5">
          <input-text type="text" v-model="address" placeholder="Default Address"></input-text>
        </div>
        <!-- <div class="pt-3">
          <input-text type="text" v-model="referral_code" placeholder="Referral Code (Optional)"></input-text>
        </div> -->
        <div class="pt-5 pb-2 text-sm">
          <div>
            By proceeding to create your account, your are agreeing to our
            <div class="font-bold inline-block" @click="terms = true">Terms of Service</div>
          </div>
        </div>
        <div class="pt-5 text-xs" @click="complete">
          <input-button>Complete Registration</input-button>
        </div>
      </div>
    </div>
    <terms-conditions v-if="terms" v-on:terms-condition="termsCondition"></terms-conditions>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import LogoBlack from '../../components/icons/LogoBlack.vue'
import InputButton from '../../components/inputs/InputButton.vue'
import InputText from '../../components/inputs/InputText.vue'
import TermsConditions from '../TermsConditions.vue'
export default {
  components: { LogoBlack, InputText, InputButton, TermsConditions },
  data() {
    return {
      first_name: '',
      last_name: '',
      email: null,
      address: '',
      referral_code: null,
      terms: false
    }
  },
  methods: {
    complete() {
      if (this.validate()) {
        var details = {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          address: this.address,
          referral_code: this.referral_code
        }
        this.$store.dispatch('complete_registration/complete', details)
      }
    },
    validate() {
      if (this.first_name != '' && this.last_name != '' && this.address != '') {
        return true
      } else {
        Swal.fire('', 'Fill required fields')
      }
    },
    termsCondition(val) {
      this.terms = val
    }
  },
  mounted() {
    this.$store.dispatch('middleware/isLoggedIn')
  }
}
</script>
